import { request } from "../request"

// Types for User Bands count response
export interface UserBandsCountResponse {
  success: true
  total_count: number
  notifiers_count: number
}

export interface UserBandsCountErrorResponse {
  success: false
  error?: string
}

/**
 * Get the total unique follower count for multiple bands
 * @param bandIds - Array of band IDs to count followers for
 * @returns Promise<UserBandsCountResponse | UserBandsCountErrorResponse>
 */
export const getUserBandsCount = async (
  bandIds: number[],
): Promise<UserBandsCountResponse | UserBandsCountErrorResponse> => {
  try {
    const path = "/api/v1/user_bands/count"

    const response = await request({
      queryKey: [
        "user_bands_count",
        {
          path,
          options: { method: "GET" },
          params: {
            band_ids: bandIds,
          },
        },
      ],
    })

    return response
  } catch (error) {
    console.error("Error fetching user bands count:", error)
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    }
  }
}
